import { Box, Group, Stack } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import Button from 'components/Button';
import { FormWrapperProps } from 'components/forms/FormWrapper';

type OverlayFormProps = Pick<
  FormWrapperProps,
  'children' | 'footerRightSide' | 'loading' | 'onSecondaryClick' | 'onSubmit' | 'primaryButtonText' | 'primaryIcon'
> & { skipSecondaryButtonConfirm?: boolean };

/** A semantic form with controls owned by its containing modal or drawer. */
export default function OverlayForm({
  children,
  footerRightSide,
  loading,
  onSecondaryClick,
  onSubmit,
  primaryButtonText,
  primaryIcon,
}: OverlayFormProps) {
  return (
    <form onSubmit={onSubmit}>
      <Stack data-overlay-form-content spacing={0} pb={16}>
        {children}
      </Stack>
      <Box
        data-e2e-capture-role="form-footer"
        pos="sticky"
        bottom={0}
        bg="white"
        py={16}
        sx={(theme) => ({ zIndex: 50, borderTop: `1px solid ${theme.colors.gray[1]}` })}
      >
        <Group position="apart" spacing={12}>
          <Group spacing={16}>
            <Button type="submit" variant="primary" size="md" leftIcon={primaryIcon} loading={loading}>
              {primaryButtonText}
            </Button>
            <Button
              type="button"
              variant="tertiary"
              size="md"
              leftIcon={<IconX stroke="1.5" height={24} width={24} />}
              disabled={loading}
              onClick={onSecondaryClick}
            >
              Zrušiť
            </Button>
          </Group>
          {footerRightSide}
        </Group>
      </Box>
    </form>
  );
}
